import { render, staticRenderFns } from "./developers.vue?vue&type=template&id=dbbb5554&"
import script from "./developers.vue?vue&type=script&lang=ts&"
export * from "./developers.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports